/**
 * Copyright 2020 New Light Technologies, Inc.
 *
 * With Supporting Sponsorship from the Federal Emergency Management Agency (Contract: GSA Stars II GS-06F-0968Z)
 * In accordance with FAR 52.227-14(c)(iii), New Light Technologies, Inc. grants to the Government and others acting on its behalf a paid-up, nonexclusive, irrevocable, worldwide license in such copyrighted computer software and data to reproduce, prepare derivative works, and perform publicly and display publicly (but not to distribute copies to the public) by or on behalf of the Government.
 * Any other use, distribution, reproduction, modification, or publication without the prior express written authorization of New Light Technologies, Inc. is strictly prohibited.
 * All other rights are reserved by their respective copyright holders.
 *
 */
import type { FeatureCollection, Polygon } from 'geojson';
import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { fetchFlatGeobuf } from '../services/featuresApi';
import { POSTProperties } from './types';

export async function asyncGetPostData(): Promise<FeatureCollection<Polygon, POSTProperties>> {
  return fetchFlatGeobuf<Polygon, POSTProperties>('ipaws_post');
}

export const postDataChunksAtom = atomFamily((_param: string) =>
  atom<FeatureCollection<Polygon, POSTProperties>>({
    type: 'FeatureCollection',
    features: [],
  })
);

export const postDataChunkIdsAtom = atom<string[]>([]);

export const postChunksSelector = atom(get => {
  const postDataChunkIds = get(postDataChunkIdsAtom);
  const postDataChunks = postDataChunkIds.map(id => get(postDataChunksAtom(id)));
  return postDataChunks ?? [];
});

export const allPostChunksSelector = atomFamily((visible: boolean) =>
  atom(async () => {
    if (!visible) return [];
    const data = await asyncGetPostData();
    return [data];
  })
);
